import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const BannerWarningState = Record({
    warnings: List(),
});

const BannerWarning = Record({
    canDismiss: false,
    backgroundColor: '',
    fontColor: '',
    text: '',
    link: '',
});

function warningFromAPI(data) {
    return new BannerWarning({
        ...data,
    });
}

export default handleActions(
    {
        [Actions.addWarnings.type]: (state, {payload}) =>
            state.merge({
                warnings: List(payload.warnings.map(warningFromAPI)),
            }),
        [Actions.dismissWarning.type]: (state, {payload}) =>
            state.merge({
                warnings: state.warnings.delete(payload.index),
            }),
    },
    new BannerWarningState(),
);
